<div>

  <app-app-dashboard-navigation></app-app-dashboard-navigation>

<div class="nav-under px-5 py-2">
  <div *ngFor="let cropItem of crops" class="crop">
    <a routerLink="/crops/{{cropItem.crop} }" class="withImage">
      <img src='{{ "https://storage.googleapis.com/ezyagric-media" + cropItem.photo_url }}' /> {{ cropItem.crop}}
    </a>
  </div>
</div>
<div class="spinner d-flex" *ngIf="loading">
    <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
</div>

<div class="dash-section m-5 p-3 bg-white">
  <div class="m-4">
    <div class="col font-weight-bold text-black-50 ">
      Agronomical Information
    </div>
    <div class="col" (click)="showFilter = !showFilter">
      <button class="btn float-right btn-md text-white px-3 filter-orange-bg mt-n4" id="toggleMessage">
        <span *ngIf="!showFilter">Show filter<i class="fas fa-chevron-down"></i></span>
        <span *ngIf="showFilter">Hide filter<i class="fas fa-chevron-up"></i></span>
      </button>
    </div>
  </div>
  <hr />
  <div class="row py-1 m-4 border-bottom filter-panel" *ngIf="showFilter">
    <form  #filterCropInfo="ngForm" id="cropForm">
    <div class="col-5">
      <p class="font-weight-bold">Activity</p>
      <select class="w-100 custom-select" id="crop_name" name="cropName" ngModel #cropName="ngModel">
         <option value="{{ row.test.crop }}" *ngFor= "
         let row of crops
           ">{{ row.test.crop }}</option>
      </select>
    </div>
    <div class="col-5">
      <p class="font-weight-bold">Title</p>
      <select class="w-100 custom-select">
         <option>All</option>
      </select>
    </div>
    <button
          class="btn btn-md filter-teal-bg text-white apply"
          (click)="filterCrop(filterCropInfo.value)"
        >
          Apply
        </button>
    <!-- <div class="col-2 buttons" align="right">
        <button
          class="btn btn-md filter-teal-bg text-white apply"
        >
          Apply
        </button>
        <button
          class="btn btn-md bg-dark disabled text-white clear"
        >
          Clear
        </button>
      </div> -->
    </form>
  </div>
</div>

<div class="dash-section m-5 bg-white">
        <div class="m-4">&nbsp;</div>
    <div class="m-4 row">
      <div class="col-4 p-4">
        <span class="btn float-left">
          Agronomical Information
        </span>
      </div>
      <div class="col-8 p-4">
        <button class="float-right btn bg-primary text-white"
        data-toggle="modal"
        data-target="#agroModal"
        >
          <i class="fas fa-plus mr-2"></i>Add Agronomical Information
        </button>
        <button
        class="float-right btn bg-navy mx-3 py-2"
        data-toggle="modal"
        data-target="#cropModal"
        >
        <i class="fas fa-plus mr-2"></i>Add Crop
        </button>
        <button
        class="float-right btn bg-navy mx-3 py-2 text-white"
        >
        <a class="text-white" routerLink="/mobile-agronomical-heading"><i class="fas fa-plus mr-2"></i>Agronomical Headings</a>
        </button>
      </div>
    </div>
    <div class="form-group custom-form">

    </div>
    <div class="m-5">
      <!-- <table class="table table-striped ">
        <thead w-100 class="table_head"> -->
      <p-table #agronoT
      [value]="filteredData"
      [columns]="columns"
      [paginator]="true"
      [rows]="10"
      [loading]="loading"
      [rowsPerPageOptions]="[10,20,30,40,50]"
      class="table table-striped "
      >
      <ng-template pTemplate="caption">
        <div style="text-align: right">
            <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Search..." (input)="agronoT.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
    </ng-template>
      <ng-template pTemplate="header" class="table_head">
          <tr>
            <th scope="col" style="width: 40px; background-color: rgb(89, 170, 233);color: white;">#</th>
            <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Activity</th>
            <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Image</th>
            <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Crop</th>
            <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Title</th>
            <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Description</th>
            <th scope="col" style="background-color: rgb(89, 170, 233);color: white;">Action</th>
          </tr>
          <tr>
            <th></th>
            <th>
              <p-multiSelect
              id="activities"
              #_activities="ngModel"
              [(ngModel)]="activity"
              [options]="chosenActivities"
              defaultLabel="All Activities"
              (onChange)="agronoT.filter($event.value, 'purpose', 'in')">
              </p-multiSelect>
            </th>
            <th></th>
             <th>
              <p-multiSelect
              id="chooseCrops"
              #choose_Crops="ngModel"
              [(ngModel)]="crop"
              [options]="chosenCrops"
              defaultLabel="All Crops"
              (onChange)="agronoT.filter($event.value, 'crop', 'in')">
              </p-multiSelect>
            </th>
            <th>
              <p-multiSelect
              id="chooseTitle"
              #choose_Title="ngModel"
              [(ngModel)]="choosetitle"
              [options]="chosenTitles"
              defaultLabel="All Titles"
              (onChange)="agronoT.filter($event.value, 'title', 'in')">
              </p-multiSelect>
            </th>
            <th></th>
            <th><button
              (click)="Clear(agronoT)"

              style="float: right;"
              class="btn btn-md bg-dark disabled text-white clear"
              >
              Clear Filters
              </button></th>
          </tr>
        <!-- </thead> -->
        <!-- <tbody p-5> -->
        </ng-template>
        <ng-template pTemplate="body" let-row>

          <tr>
            <td> {{ filteredData.indexOf(row)+1 }}</td>
            <td>{{ row.purpose }}</td>
            <td><img src='{{ "https://storage.googleapis.com/ezyagric-media" + row.photo_url }}' width="80" height="80" alt="{{row.crop}}" /></td>
            <td>{{ row.crop }}</td>
            <td>{{ row.title }}</td>
            <td [innerHTML]="row.description | truncateText:150" class="text" style="border: none;"></td>
            <td>
              <div class="dropdown">
                <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                  data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  ACTION
                </button>
                <div class="dropdown-menu options" aria-labelledby="dropdownMenuButton">
                  <div id="edit" (click)="setAction(row, 'edit')">
                    <a class="dropdown-item items"
                      data-toggle="modal"
                      data-target="#viewModal"
                      (click)="viewInfoDetails( row )"
                    >View</a>
                  </div>
                  <a
                  class="dropdown-item suspend"
                  data-toggle="modal"
                  data-target="#inputModal"
                  (click)="editInfoDetails( row,row.input )"
                  >Edit</a
                  >
                  <a
                  class="dropdown-item activate"
                  data-toggle="modal"
                  data-target="#deleteModal"
                  (click)="deleteInfoDetails( row )"
                  >Delete</a
                  >
                </div>
              </div>
            </td>
          </tr>
        <!-- </tbody>
      </table> -->
    </ng-template>
    </p-table>
      <!-- <nav aria-label="Page navigation example">
          <pagination-controls (pageChange)="page = $event"></pagination-controls>
      </nav> -->
      <div class="spinner d-flex" *ngIf="loading">
          <span class="spinner-border spinner-border-md mx-auto update-loading" role="status"></span>
      </div>
      <div class="m-4">&nbsp;</div>
    </div>
    <div class="m-4">&nbsp;</div>
</div>
</div>

<div class="modal fade" id="viewModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Agronomical Details</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body agronomical-view-details">
            <div class="container-fluid" *ngIf="cropInfoData">
                <div class="row my-2 py-2">
                    <div class="col text-secondary">Activity</div><div class="col">{{ cropInfoData.purpose }}</div>
                </div>
                <div class="row my-2 py-2">
                    <div class="col text-secondary">Crop</div><div class="col">{{ cropInfoData.crop }}</div>
                </div>
                <div class="row my-2 py-2">
                    <div class="col text-secondary">Title</div><div class="col">{{ cropInfoData.title }}</div>
                </div>
                <div class="row my-2 py-2">
                    <div class="col text-secondary">Description</div><div class="col" [innerHTML]="cropInfoData.description"></div>
                </div>
              </div>
          </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="inputModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Edit Details</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body" *ngIf="editAgroInfoisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
              <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
              <h4>Success!</h4>
              <p><span class="text-center">Agronomical info edited successfully</span></p>
              <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetEditModal()">OK</button>
          </div>

          <div class="modal-body agronomical-view-details" *ngIf="!editAgroInfoisSuccess">
            <span class="text-center alert alert-danger" *ngIf="editError">{{ message }}</span>
            <div class="container-fluid" *ngIf="editInfoData">
              <form *ngIf="editInfoData" (submit)="handleSubmit(updateInfoForm.value, editInfoData.id)" #updateInfoForm="ngForm"
              class="px-2 py-2">
              <div class="form-group">
                <label for="crop">Name of Crop</label>
                <!-- <input type="text" class="form-control change-input-field" placeholder="name of crop" name="crop"
                  value="{{ editInfoData.crop }}" #crop="ngModel" [(ngModel)]="editInfoData.crop" minlength="3" /> -->

                  <select
                  class="form-control form-control"
                  name="crop"
                  #crop="ngModel"
                  ngModel
                  [(ngModel)]="editInfoData.crop"
                >
                  <option *ngFor="let cropItem of cropData.data" class="crop">
                    {{ cropItem.crop }}
                  </option>
                </select>

              </div>
              <!-- <div class="form-group">
                <label for="purpose">purpose</label>
                <input type="text" class="form-control change-input-field" #purpose="ngModel" [(ngModel)]="editInfoData.purpose"
                 value="{{ editInfoData.purpose }}" placeholder="purpose" name="purpose" />
              </div> -->

              <div class="form-group">
                <label for="purpose">Purpose</label>

                  <select
                  class="form-control form-control"
                  name="purpose"
                  #purpose="ngModel"
                  ngModel
                  [(ngModel)]="editInfoData.purpose"
                >
                  <option *ngFor="let cropItem of cropHeading.data" class="crop">
                    {{ cropItem.name }}
                  </option>
                </select>

              </div>

              <div class="form-group">
                <label for="title">Title</label>
                <input type="text" class="form-control
                            change-input-field" #title="ngModel" [(ngModel)]="editInfoData.title" placeholder="title" value="{{ editInfoData.title }}" name="title" />
              </div>

              <div class="form-group">
                <label for="description">description</label>
                <!-- <textarea type="text" class="form-control md-textarea" #description="ngModel" [(ngModel)]="editInfoData.test.description" placeholder="crops" name="description"
                  value="{{ editInfoData.test.description[0] }}" ></textarea> -->
                  <quill-editor
                    name="description"
                    #description="ngModel"
                    [(ngModel)]="editInfoData.description"
                    [modules]="quillConfig"
                    (onEditorChanged)="clearErrorMessage(description)"
                  >
                  </quill-editor>
              </div>
              <div class="form-group">
                <label for="title">Current Position on app</label>
                <input type="number" class="form-control
                            change-input-field" #position="ngModel" [(ngModel)]="editInfoData.position" placeholder="position on app" value="{{ editInfoData.position }}" name="position" />
              </div>
              <div class="form-group" style="height: 350px;" *ngIf="country_name === 'Uganda'">
                <label for="input">Recommended Fertilizer/Pesticide</label><br>
                <input type="text" placeholder="search" id="searchBox" (keyup)="filterFunction()">
                <select
                  class="form-control form-control"
                  id="diagnosisCrop"
                  name="input"
                  #input="ngModel"
                  [(ngModel)]="editInfoData.input"
                  style="height: 90%;"
                  multiple
                >
                <option selected
                  *ngFor="let selected of selectedInfo"
                  value="{{selected.id}}">{{ selected.name }}</option>
                  <option *ngFor="let inputItem of filterInputs" value="{{inputItem.id}}" class="crop">
                    {{ inputItem.name }}
                  </option>
                </select>
              </div><br>

              <div class="form-group">
                <label for="input">Recommended Service</label>
                <!-- <input type="text" placeholder="search" id="searchBox" (keyup)="filterFunction()"> -->
                <select
                  class="form-control form-control"
                  id="diagnosisCrop"
                  name="service"
                  #service="ngModel"
                  [(ngModel)]="editInfoData.service"
                  multiple
                >
                  <option *ngFor="let inputItem of parts" value="{{inputItem}}" class="crop">
                    {{ inputItem }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label for="photo">Image</label>
                <input type="file" value="CHOOSE FILE" name="photo" class="form-control change-files"
                  (change)="changeImage($event)" accept="image/png, image/jpeg, image/jpg" />
              </div>
              <div class="d-flex justify-content-center align-item-center form-group">
                <button type="submit" class="submit-input-btn" >
                  <span *ngIf="loading" class="spinner-border spinner-border-md
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Save Info
                  </span>
                </button>
              </div>
            </form>
              </div>
          </div>
        <div class="modal-footer" *ngIf="!editAgroInfoisSuccess">
            <a
            class="btn btn-danger text-white"
            data-dismiss="modal"
            data-toggle="modal"
            data-target="#deleteModal"
            (click)="deleteInfoDetails( editInfoData )"
            >Delete</a
            >
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="cropModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Add Crop</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body" *ngIf="createCropIsSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
            <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
            <h4>Success!</h4>
            <p><span class="text-center">{{message}}</span></p>
            <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetModal()">OK</button>
        </div>

          <div class="modal-body agronomical-view-details" *ngIf="!createCropIsSuccess">
            <span class="text-center alert alert-danger" *ngIf="createCropIsFailed">{{ message }}</span>
            <div class="container-fluid">
              <form (submit)="createCrop(createCropForm.value)" #createCropForm="ngForm"
              class="px-2 py-2">
              <div class="form-group">
                <label for="name">Name of Crop</label>
                <input type="text" class="form-control change-input-field" placeholder="name of crop" name="name"
                ngModel #name="ngModel" minlength="3" />
              </div>
              <div class="form-group">
                <label for="photo">Image</label>
                <input type="file" value="CHOOSE FILE" name="photo" class="form-control change-files"
                  (change)="changeImage($event)" accept="image/png, image/jpeg, image/jpg" />
              </div>
              <div class="d-flex justify-content-center align-item-center form-group">
                <button type="submit" class="submit-input-btn" >
                  <span *ngIf="loading" class="spinner-border spinner-border-md
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Create Crop
                  </span>
                </button>
              </div>
            </form>
              </div>
          </div>
        <div class="modal-footer" *ngIf="!createCropIsSuccess">
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="agroModal">
    <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 50%;">
      <div class="card modal-content">
          <div class="modal-header">
              <h4 class="modal-title text-info" id="modal-basic-title">Add Agronomical Information</h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body" *ngIf="createAgroInfoisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
              <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
              <h4>Success!</h4>
              <p><span class="text-center">Agronomical info added successfully</span></p>
              <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetModal()">OK</button>
          </div>

          <div class="modal-body agronomical-view-details" *ngIf="!createAgroInfoisSuccess">
            <span class="text-center alert alert-danger" *ngIf="serverError">{{ message }}</span>
            <div class="container-fluid">
              <form (submit)="createAgroInfo(agroInfoForm.value)" #agroInfoForm="ngForm"
              class="px-2 py-2">
              <div class="form-group">
                <label for="name">Name of Crop</label>
                <!-- <input type="text" class="form-control change-input-field" placeholder="name of crop" name="name"
                ngModel #name="ngModel" minlength="3" /> -->

                <select
                  class="form-control form-control"
                  id="diagnosisCrop"
                  name="name"
                  #name="ngModel"
                  ngModel
                  required
                >
                  <option *ngFor="let cropItem of cropData.data" class="crop">
                    {{ cropItem.crop }}
                  </option>
                </select>

              </div>
              <!-- <div class="form-group">
                <label for="purpose">purpose</label>
                <input type="text" class="form-control change-input-field" ngModel #purpose="ngModel"
                 placeholder="purpose" name="purpose" />
              </div> -->

              <div class="form-group">
                <label for="crop">purpose</label>

                  <select
                  class="form-control form-control"
                  name="purpose"
                  #purpose="ngModel"
                  ngModel
                  required
                >
                  <option *ngFor="let cropItem of cropHeading.data" class="crop">
                    {{ cropItem.name }}
                  </option>
                </select>

              </div>

              <div class="form-group">
                <label for="title">Title</label>
                <input type="text" class="form-control
                            change-input-field" ngModel #title="ngModel" placeholder="title" name="title" />
              </div>

              <div class="form-group">
                <label for="description">description</label>
                <!-- <textarea type="text" class="form-control md-textarea" #description="ngModel" ngModel placeholder="crops" name="description"
                  ></textarea> -->
                  <quill-editor
                    name="description"
                    #description="ngModel"
                    [(ngModel)]="model.description"
                    [modules]="quillConfig"
                    (onEditorChanged)="clearErrorMessage(description)"
                  >
                  </quill-editor>
              </div>
              <div class="form-group">
                <label for="purpose">position on app</label>
                <input type="number" class="form-control change-input-field" ngModel #position="ngModel"
                 placeholder="Position sub heading should appear on app" name="position" />
              </div>

              <div class="form-group" style="height: 350px;" *ngIf="country_name === 'Uganda'">
                <label for="input">Recommended Fertilizer/Pesticide</label><br>
                <input type="text" placeholder="search" id="searchBox" (keyup)="filterFunction()">
                <select
                  class="form-control form-control"
                  id="diagnosisCrop"
                  name="input"
                  #input="ngModel"
                  [(ngModel)]="model.input"
                  style="height: 90%;"
                  multiple
                >
                  <option *ngFor="let inputItem of filterInputs" value="{{inputItem.id}}" class="crop">
                    {{ inputItem.name }}
                  </option>
                </select>
              </div><br>

              <div class="form-group">
                <label for="input">Recommended Service</label>
                <!-- <input type="text" placeholder="search" id="searchBox" (keyup)="filterFunction()"> -->
                <select
                  class="form-control form-control"
                  id="diagnosisCrop"
                  name="service"
                  #service="ngModel"
                  [(ngModel)]="model.service"
                  multiple
                >
                  <option *ngFor="let inputItem of parts" value="{{inputItem}}" class="crop">
                    {{ inputItem }}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label for="photo">Image</label>
                <input type="file" value="CHOOSE FILE" name="photo" class="form-control change-files"
                  (change)="changeImage($event)" accept="image/png, image/jpeg, image/jpg" />
              </div>
              <div class="d-flex justify-content-center align-item-center form-group">
                <button type="submit" class="submit-input-btn" >
                  <span *ngIf="loading" class="spinner-border spinner-border-md
                    text-white change-loading" role="status"></span>
                  <span *ngIf="loading" class="mx-2">Loading...</span>
                  <span *ngIf="!loading">
                    Create
                  </span>
                </button>
              </div>
            </form>
              </div>
          </div>
        <div class="modal-footer" *ngIf="!createAgroInfoisSuccess">
          <button type="button" class="btn btn-warning" data-dismiss="modal">
            <span class="text-white">CLOSE</span>
          </button>
        </div>
      </div>
    </div>
  </div>


  <!-- Delete Input -->
<div class="modal fade" id="deleteModal">
  <div class="modal-dialog change-modal-dialog" role="document">
    <div class="modal-content" *ngIf="deleteInfoData">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Delete Agronomical Info</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" *ngIf="deleteAgroInfoisSuccess" style="text-align: center; padding: 3rem 0 3rem 0;">
        <i class="far fa-check-circle fa-3x" style="color: teal; padding: 1rem 0 1rem 0"></i>
        <h4>Success!</h4>
        <p><span class="text-center">Agronomical info deleted successfully</span></p>
        <button class="btn btn-success px-3 filter-teal-bg text-white" data-dismiss="modal" (click)="resetDeleteModal()">OK</button>
    </div>
      <div class="modal-body" *ngIf="!deleteAgroInfoisSuccess">
        Are you sure you want to delete {{ deleteInfoData.crop }}
      </div>
      <div class="modal-footer" *ngIf="!deleteAgroInfoisSuccess">
        <span class="text-danger" *ngIf="deleteError">Some error occurred. Please try again</span>
        <button *ngIf="deleteError" class="btn btn-danger" data-dismiss="modal" (click)="resetDeleteModal()">OK</button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="deleteInput(deleteInfoData.id)"
        >
          <span
            *ngIf="loading"
            class="spinner-border spinner-border-md text-white
              update-loading"
            role="status"
          ></span>
          Delete Input
        </button>
        <button type="button" class="btn btn-outline-dark" data-dismiss="modal">
          Close
        </button>
      </div>
    </div>

<div class="modal fade" id="cropModal">
  <div class="modal-dialog change-modal-dialog" role="document">
  <!-- Modal -->
  <app-add-crop-modal
    *ngIf="addModal"
    (successAddCropEvent)=" refreshCropList()"
    (successMessage)="getMessage($event)"
  >
  </app-add-crop-modal>

  <app-success-modal
  *ngIf="successModal && message"
  [message]="message"
  (clearCropEvent)="clearCropId()"
  >
 </app-success-modal>
  </div>
</div>
